import type { ProductSortColumn } from './types'

const WIRE_NAME_BY_COLUMN: Record<ProductSortColumn, string> = {
  title: 'title',
  brandName: 'brand_name',
  price: 'price',
  sku: 'sku',
  externalId: 'external_id',
  createdAt: 'created_at',
}

export function sortColumnToWireName(column: ProductSortColumn): string {
  return WIRE_NAME_BY_COLUMN[column]
}
